import type { RouteRecordRaw } from 'vue-router';

/**
 * Rotas para as paginas do deal
 *
 * Estrutura:
 * - DealById tela princial - "Detalhe do deal na sidebar"
 *   └─ children (tabs): que recebem o id do deal por parametro dos detalhes do deal
 *      ├─ DealSummary
 *      ├─ DealMyProposal
 *      └─ AcceptsDeal
 */
export const dealRoutes: Array<RouteRecordRaw> = [
  {
    path: 'deal/:dealId',
    props: true,
    component: () => import('@/views/private/deal/DealById.vue'),
    children: [
      {
        name: 'DealSummary',
        path: '',
        props: true,
        component: () => import('@/views/private/deal/DealSummary.vue'),
      },
      {
        name: 'DealEdit',
        path: 'edit',
        props: true,
        component: () => import('@/views/private/deal/DealEdit.vue'),
        children: [
          {
            props: true,
            name: 'DealFormProduct',
            path: 'product',
            alias: '',
            component: () =>
              import('@/views/private/deal/form/DealFormProduct.vue'),
          },
          {
            props: true,
            name: 'DealFormCustomer',
            path: 'customer/:associateId?',
            component: () =>
              import('@/views/private/deal/form/DealFormCustomer.vue'),
          },
          {
            props: true,
            name: 'DealFormCompany',
            path: 'company/:associateId?',
            component: () =>
              import('@/views/private/deal/form/DealFormCompany.vue'),
          },
          {
            props: true,
            name: 'DealFormViewer',
            path: 'viewer/:associateId?',
            component: () =>
              import('@/views/private/deal/form/DealFormViewer.vue'),
          },
          {
            props: true,
            name: 'DealFormAsset',
            path: 'asset',
            component: () =>
              import('@/views/private/deal/form/DealFormAsset.vue'),
          },
          {
            props: true,
            name: 'DealFormFiles',
            path: 'files',
            component: () =>
              import('@/views/private/deal/form/DealFormFiles.vue'),
          },
          {
            props: true,
            name: 'DealFormSaveAndExit',
            path: 'save',
            component: () =>
              import('@/views/private/deal/form/DealFormSaveAndExit.vue'),
          },
          {
            props: true,
            name: 'DealFormCompleted',
            path: 'success',
            component: () =>
              import('@/views/private/deal/form/DealFormCompleted.vue'),
          },
          {
            props: true,
            name: 'DealFormIncomplete',
            path: 'incomplete',
            component: () =>
              import('@/views/private/deal/form/DealFormIncomplete.vue'),
          },
          {
            props: true,
            name: 'DealFormFilesCompleted',
            path: 'files-success',
            component: () =>
              import('@/views/private/deal/form/DealFormFilesCompleted.vue'),
          },
          {
            props: true,
            name: 'DealFormFilesIncomplete',
            path: 'files-incomplete',
            component: () =>
              import('@/views/private/deal/form/DealFormFilesIncomplete.vue'),
          },
        ],
      },
      {
        name: 'DealProposal',
        path: 'proposal',
        props: true,
        component: () => import('@/views/private/deal/DealMyProposal.vue'),
      },
      {
        name: 'DealAuthorizations',
        path: 'authorizations',
        props: true,
        component: () => import('@/views/private/deal/DealAuthorizations.vue'),
      },
      {
        name: 'DealRealtyEvaluate',
        props: true,
        path: 'realty-evaluate',
        component: () => import('@/views/private/deal/DealEvaluate.vue'),
      },
      {
        name: 'DealLegalAnalysisRequest',
        props: true,
        path: 'legal-analysis',
        component: () =>
          import('@/views/private/deal/DealLegalAnalysisRequest.vue'),
      },
      {
        name: 'CreditAnalysis',
        props: true,
        path: 'credit-analysis',
        component: () => import('@/views/private/deal/CreditAnalysis.vue'),
      },
      {
        name: 'BextIA',
        props: true,
        path: 'bext-ia',
        component: () => import('@/views/private/deal/BextIA.vue'),
      },
    ],
  },
  //acrescentado para manter funcionando links de produção enviados por e-mail para acompanhamento do deal
  {
    path: 'deal/view/:dealId',
    props: true,
    component: () => import('@/views/private/deal/DealById.vue'),
    children: [
      {
        name: 'DealViewSummary',
        path: '',
        props: true,
        component: () => import('@/views/private/deal/DealSummary.vue'),
      },
      {
        name: 'DealViewProposal',
        path: 'proposal',
        props: true,
        component: () => import('@/views/private/deal/DealMyProposal.vue'),
      },
      {
        name: 'DealViewAuthorizations',
        path: 'authorizations',
        props: true,
        component: () => import('@/views/private/deal/DealAuthorizations.vue'),
      },
      {
        name: 'DealViewRealtyEvaluate',
        props: true,
        path: 'realty-evaluate',
        component: () => import('@/views/private/deal/DealEvaluate.vue'),
      },
      {
        name: 'DealViewLegalAnalysisRequest',
        props: true,
        path: 'legal-analysis',
        component: () =>
          import('@/views/private/deal/DealLegalAnalysisRequest.vue'),
      },
    ],
  },

  // Redirecionamento criado p os links em prod enviado por email continuarem funcionando e as url seguirem o novo padrao do projeto deal/{dealID}/tela
  {
    path: 'deal/form',
    redirect: '/deal/new/edit',
  },
  {
    path: 'deal/form/:dealId',
    redirect: (to) => ({
      path: `/deal/${to.params.dealId}/edit`,
    }),
  },
  {
    path: 'deal/form/:dealId/:pathMatch(.*)*',
    redirect: (to) => ({
      path: `/deal/${to.params.dealId}/edit/${(to.params.pathMatch as string[])?.join('/') ?? ''}`,
    }),
  },
];
